export function clamp(value: number, min: number, max: number) {
    return Math.max(min, Math.min(max, value));
}

export function ease(from: number, to: number, amount: number, rounded = false) {
    const difference = to - from;
    if (Math.abs(difference) <= (rounded ? 1 : 0.0001)) {
        return to;
    }
    const value = from + (to - from) * amount;
    return rounded ? Math.round(value) : value;
}

export function percentage(value?: number) {
    return round(100 * (value || 0));
}

export function random(min: number, max: number, rounded = false) {
    const low = Math.min(min, max);
    const high = Math.max(min, max);
    const value = (high - low) * Math.random() + low;
    return rounded ? Math.round(value) : value;
}

export function round(value?: number) {
    const val = value || 0;
    const decimals = 4 - clamp(Math.floor(Math.abs(val)).toString().length, 0, 4);
    const multiplier = Math.pow(10, decimals);
    return Math.round((value || 0) * multiplier) / multiplier;
}